module.exports = __webpack_public_path__ + "img/icon-tres-puntos.a304e342.svg";